/* This file was created automatically, don't change it manually. */

import React, { forwardRef } from 'react';

import { ColorlessIconProps } from '../../types';
import { SVGContainer } from '../../SVGContainer';

const IconRefresh16 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconRefresh16(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 16 16" ref={ref}>
            <path
                d="M6.607 1.135 7.55.193l3.138 3.138L7.55 6.469l-.943-.943 1.526-1.527A4.667 4.667 0 1 0 11.3 5.364l.944-.943a6 6 0 1 1-4.106-1.756l-1.53-1.53Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

const IconRefresh24 = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconRefresh24(props, ref) {
    return (
        <SVGContainer {...props} viewBox="0 0 24 24" ref={ref}>
            <path
                d="M9.91 1.703 11.324.29l4.707 4.707-4.707 4.707L9.91 8.29 12.2 6a7 7 0 1 0 4.75 2.047l1.414-1.414a9 9 0 1 1-6.159-2.634L9.91 1.703Z"
                fill="currentColor"
            />
        </SVGContainer>
    );
});

export const IconRefresh = forwardRef<SVGSVGElement, ColorlessIconProps>(function IconRefresh(props, ref) {
    const { size = '16', role = 'supplementary' } = props;

    const iconProps = {
        ...props,
        size,
        ref,
        role,
        colorless: true,
    } as const;

    switch (size) {
        case '16':
            return <IconRefresh16 {...iconProps} />;
        case '24':
            return <IconRefresh24 {...iconProps} />;
        default:
            return <IconRefresh24 {...iconProps} />;
    }
});
